<template>
  <div class="pt-2">
    <div class="d-flex align-center justify-end mb-3">
      <v-switch :input-value="config.enabled" label="Requête active" dense hide-details class="mt-0" @change="change('enabled', $event)" />
      <v-btn small text color="error" class="ml-3" @click="$emit('remove')">
        <v-icon left small>mdi-delete</v-icon>Supprimer
      </v-btn>
    </div>
      <v-row dense>
        <v-col cols="12" md="5"><v-text-field :value="config.name" label="Nom" outlined dense @input="change('name', $event)" /></v-col>
        <v-col cols="12" md="4"><v-autocomplete :value="config.table" :items="tables" label="Table" clearable outlined dense @input="change('table', $event || '')" /></v-col>
        <v-col cols="12" md="3"><v-text-field :value="config.target" label="Clé pour utilisation dans les visuels" placeholder="production" outlined dense @input="change('target', $event)" /></v-col>
      </v-row>
      <v-row dense>
        <v-col cols="12" md="4"><v-combobox :value="config.eventTypes" :items="eventTypes" label="Types d’événements" multiple chips deletable-chips clearable outlined dense @input="change('eventTypes', $event || [])" /></v-col>
        <v-col cols="12" md="4"><v-autocomplete :value="config.collectField" :items="providerFields" label="Champ collecté dans l’événement" clearable outlined dense @input="change('collectField', $event || '')" /></v-col>
        <v-col cols="12" md="4"><v-select :value="config.valueType" :items="valueTypes" label="Type des identifiants" outlined dense @input="change('valueType', $event)" /></v-col>
      </v-row>
      <v-row dense>
        <v-col cols="12" md="4"><v-text-field :value="config.queryFilterField" label="Champ SQL filtré par IN" placeholder="productions.id" hint="Clé moteur ou table.colonne déclarée dans la requête" persistent-hint outlined dense @input="change('queryFilterField', $event)" /></v-col>
        <v-col cols="12" md="4"><v-autocomplete :value="config.correlationAlias" :items="aliases" label="Alias de corrélation retourné" clearable outlined dense @input="change('correlationAlias', $event || '')" /></v-col>
        <v-col cols="12" md="4"><v-select :value="config.cardinality" :items="cardinalities" label="Cardinalité" outlined dense @input="change('cardinality', $event)" /></v-col>
      </v-row>

      <template v-if="config.table">
        <v-tabs v-model="tab" background-color="grey lighten-4" grow class="mt-3">
          <v-tab>Champs retournés</v-tab><v-tab>Filtres et relations</v-tab>
        </v-tabs>
        <v-tabs-items v-model="tab">
          <v-tab-item class="pt-3"><Fields :modalKey="modalKey" :page="page" :champs="config.champs" :filter="config.filtre" :table="config.table" /></v-tab-item>
          <v-tab-item class="pt-3"><Filtre :page="page" :filtre="config.filtre" :table="config.table" /></v-tab-item>
        </v-tabs-items>
      </template>
      <v-alert type="info" text dense class="mt-3">
        Le moteur collecte les identifiants des événements visibles, puis ajoute automatiquement un <code>WHERE IN</code> typé. La requête n’est jamais lancée sans cette restriction.
      </v-alert>
  </div>
</template>

<script>
import { admin } from '../mixins'

export default {
  name: 'TimelineQueryEditor',
  mixins: [admin],
  props: {
    config: { type: Object, required: true },
    tables: { type: Array, default: () => [] },
    providerFields: { type: Array, default: () => [] },
    eventTypes: { type: Array, default: () => [] },
    page: [String, Number],
    modalKey: [String, Number],
  },
  data: () => ({
    tab: 0,
    valueTypes: [{ text: 'Entier', value: 'integer' }, { text: 'Texte', value: 'string' }],
    cardinalities: [{ text: 'Un résultat', value: 'one' }, { text: 'Plusieurs résultats', value: 'many' }],
  }),
  computed: {
    aliases() {
      return (this.config.champs || []).filter(field => field && field.as).map(field => ({ text: field.as, value: field.as }))
    },
  },
  methods: {
    change(key, value) { this.$emit('change', { ...this.config, [key]: value }) },
  },
}
</script>
